module.exports = {
	carData: () => {
		return [
			{
				'ESCAPE TITANIUM 4X4 FHEV': {
					Nombre: 'ESCAPE TITANIUM 4X4 FHEV',
					SubTitle: '',
					Menu: [
						{
							Nombre: 'Ficha técnica',
              Slug: 'tecnica',
							Icono: require('./../UI/canvas/CarMenu/btns/ficha.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/ficha-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Galería general',
              Slug: 'gallery',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Ver accesorios',
              Slug: 'accesorios',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Personaliza tu Ford',
              Slug: 'customize',
							Icono: require('./../UI/canvas/CarMenu/btns/detalle.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/detalle-selected.svg'),
							SubMenu: [
								{
									Nombre: 'Ver exterior',
									Icono: require('./../UI/canvas/CarMenu/btns/exterior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/exterior-selected.svg'),
								},
								{
									Nombre: 'Ver interior',
									Icono: require('./../UI/canvas/CarMenu/btns/interior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/interior-selected.svg'),
								},
							],
						},
						{
							Nombre: 'Cotiza este auto',
              Slug: 'quotation',
							Icono: require('./../UI/canvas/CarMenu/btns/cotiza.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/cotiza-selected.svg'),
							SubMenu: [],
						},
					],
				},

				'ESCAPE ECOBOOST': {
					Nombre: 'Escape EcoBoost',
					SubTitle: '',
					Menu: [
						{
							Nombre: 'Ficha técnica',
              Slug: 'tecnica',
							Icono: require('./../UI/canvas/CarMenu/btns/ficha.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/ficha-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Galería general',
              Slug: 'gallery',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Ver accesorios',
              Slug: 'accesorios',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Personaliza tu Ford',
              Slug: 'customize',
							Icono: require('./../UI/canvas/CarMenu/btns/detalle.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/detalle-selected.svg'),
							SubMenu: [
								{
									Nombre: 'Ver exterior',
									Icono: require('./../UI/canvas/CarMenu/btns/exterior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/exterior-selected.svg'),
								},
								{
									Nombre: 'Ver interior',
									Icono: require('./../UI/canvas/CarMenu/btns/interior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/interior-selected.svg'),
								},
							],
						},
						{
							Nombre: 'Cotiza este auto',
              Slug: 'quotation',
							Icono: require('./../UI/canvas/CarMenu/btns/cotiza.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/cotiza-selected.svg'),
							SubMenu: [],
						},
					],
				},

				'ESCAPE SE 4X2 FHEV': {
					Nombre: 'Escape SE 4X2 FHEV',
					SubTitle: '',
					Menu: [
						{
							Nombre: 'Ficha técnica',
              Slug: 'tecnica',
							Icono: require('./../UI/canvas/CarMenu/btns/ficha.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/ficha-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Galería general',
              Slug: 'gallery',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Ver accesorios',
              Slug: 'accesorios',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Personaliza tu Ford',
              Slug: 'customize',
							Icono: require('./../UI/canvas/CarMenu/btns/detalle.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/detalle-selected.svg'),
							SubMenu: [
								{
									Nombre: 'Ver exterior',
									Icono: require('./../UI/canvas/CarMenu/btns/exterior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/exterior-selected.svg'),
								},
								{
									Nombre: 'Ver interior',
									Icono: require('./../UI/canvas/CarMenu/btns/interior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/interior-selected.svg'),
								},
							],
						},
						{
							Nombre: 'Cotiza este auto',
              Slug: 'quotation',
							Icono: require('./../UI/canvas/CarMenu/btns/cotiza.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/cotiza-selected.svg'),
							SubMenu: [],
						},
					],
				},

				'ESCAPE SEL 4X2 FHEV': {
					Nombre: 'Escape SEL 4X2 FHEV',
					SubTitle: '',
					Menu: [
						{
							Nombre: 'Ficha técnica',
              Slug: 'tecnica',
							Icono: require('./../UI/canvas/CarMenu/btns/ficha.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/ficha-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Galería general',
              Slug: 'gallery',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Ver accesorios',
              Slug: 'accesorios',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Personaliza tu Ford',
              Slug: 'customize',
							Icono: require('./../UI/canvas/CarMenu/btns/detalle.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/detalle-selected.svg'),
							SubMenu: [
								{
									Nombre: 'Ver exterior',
									Icono: require('./../UI/canvas/CarMenu/btns/exterior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/exterior-selected.svg'),
								},
								{
									Nombre: 'Ver interior',
									Icono: require('./../UI/canvas/CarMenu/btns/interior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/interior-selected.svg'),
								},
							],
						},
						{
							Nombre: 'Cotiza este auto',
              Slug: 'quotation',
							Icono: require('./../UI/canvas/CarMenu/btns/cotiza.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/cotiza-selected.svg'),
							SubMenu: [],
						},
					],
				},

				'EDGE SEL': {
					Nombre: 'Edge SEL',
					SubTitle: '',
					Menu: [
						{
							Nombre: 'Ficha técnica',
              Slug: 'tecnica',
							Icono: require('./../UI/canvas/CarMenu/btns/ficha.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/ficha-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Galería general',
              Slug: 'gallery',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Ver accesorios',
              Slug: 'accesorios',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Personaliza tu Ford',
              Slug: 'customize',
							Icono: require('./../UI/canvas/CarMenu/btns/detalle.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/detalle-selected.svg'),
							SubMenu: [
								{
									Nombre: 'Ver exterior',
									Icono: require('./../UI/canvas/CarMenu/btns/exterior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/exterior-selected.svg'),
								},
								{
									Nombre: 'Ver interior',
									Icono: require('./../UI/canvas/CarMenu/btns/interior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/interior-selected.svg'),
								},
							],
						},
						{
							Nombre: 'Cotiza este auto',
              Slug: 'quotation',
							Icono: require('./../UI/canvas/CarMenu/btns/cotiza.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/cotiza-selected.svg'),
							SubMenu: [],
						},
					],
				},

				'EDGE ST': {
					Nombre: 'Edge ST',
					SubTitle: '',
					Menu: [
						{
							Nombre: 'Ficha técnica',
              Slug: 'tecnica',
							Icono: require('./../UI/canvas/CarMenu/btns/ficha.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/ficha-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Galería general',
              Slug: 'gallery',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Ver accesorios',
              Slug: 'accesorios',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Personaliza tu Ford',
              Slug: 'customize',
							Icono: require('./../UI/canvas/CarMenu/btns/detalle.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/detalle-selected.svg'),
							SubMenu: [
								{
									Nombre: 'Ver exterior',
									Icono: require('./../UI/canvas/CarMenu/btns/exterior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/exterior-selected.svg'),
								},
								{
									Nombre: 'Ver interior',
									Icono: require('./../UI/canvas/CarMenu/btns/interior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/interior-selected.svg'),
								},
							],
						},
						{
							Nombre: 'Cotiza este auto',
              Slug: 'quotation',
							Icono: require('./../UI/canvas/CarMenu/btns/cotiza.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/cotiza-selected.svg'),
							SubMenu: [],
						},
					],
				},

				'EXPEDITION LIMITED': {
					Nombre: 'Expedition Limited',
					SubTitle: '',
					Menu: [
						{
							Nombre: 'Ficha técnica',
              Slug: 'tecnica',
							Icono: require('./../UI/canvas/CarMenu/btns/ficha.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/ficha-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Galería general',
              Slug: 'gallery',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Ver accesorios',
              Slug: 'accesorios',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Personaliza tu Ford',
              Slug: 'customize',
							Icono: require('./../UI/canvas/CarMenu/btns/detalle.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/detalle-selected.svg'),
							SubMenu: [
								{
									Nombre: 'Ver exterior',
									Icono: require('./../UI/canvas/CarMenu/btns/exterior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/exterior-selected.svg'),
								},
								{
									Nombre: 'Ver interior',
									Icono: require('./../UI/canvas/CarMenu/btns/interior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/interior-selected.svg'),
								},
							],
						},
						{
							Nombre: 'Cotiza este auto',
              Slug: 'quotation',
							Icono: require('./../UI/canvas/CarMenu/btns/cotiza.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/cotiza-selected.svg'),
							SubMenu: [],
						},
					],
				},

				'EXPLORER LIMITED': {
					Nombre: 'Explorer Limited',
					SubTitle: '',
					Menu: [
						{
							Nombre: 'Ficha técnica',
              Slug: 'tecnica',
							Icono: require('./../UI/canvas/CarMenu/btns/ficha.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/ficha-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Galería general',
              Slug: 'gallery',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Ver accesorios',
              Slug: 'accesorios',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Personaliza tu Ford',
              Slug: 'customize',
							Icono: require('./../UI/canvas/CarMenu/btns/detalle.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/detalle-selected.svg'),
							SubMenu: [
								{
									Nombre: 'Ver exterior',
									Icono: require('./../UI/canvas/CarMenu/btns/exterior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/exterior-selected.svg'),
								},
								{
									Nombre: 'Ver interior',
									Icono: require('./../UI/canvas/CarMenu/btns/interior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/interior-selected.svg'),
								},
							],
						},
						{
							Nombre: 'Cotiza este auto',
              Slug: 'quotation',
							Icono: require('./../UI/canvas/CarMenu/btns/cotiza.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/cotiza-selected.svg'),
							SubMenu: [],
						},
					],
				},

				'EXPLORER ST': {
					Nombre: 'Explorer ST',
					SubTitle: '',
					Menu: [
						{
							Nombre: 'Ficha técnica',
              Slug: 'tecnica',
							Icono: require('./../UI/canvas/CarMenu/btns/ficha.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/ficha-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Galería general',
              Slug: 'gallery',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Ver accesorios',
              Slug: 'accesorios',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Personaliza tu Ford',
              Slug: 'customize',
							Icono: require('./../UI/canvas/CarMenu/btns/detalle.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/detalle-selected.svg'),
							SubMenu: [
								{
									Nombre: 'Ver exterior',
									Icono: require('./../UI/canvas/CarMenu/btns/exterior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/exterior-selected.svg'),
								},
								{
									Nombre: 'Ver interior',
									Icono: require('./../UI/canvas/CarMenu/btns/interior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/interior-selected.svg'),
								},
							],
						},
						{
							Nombre: 'Cotiza este auto',
              Slug: 'quotation',
							Icono: require('./../UI/canvas/CarMenu/btns/cotiza.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/cotiza-selected.svg'),
							SubMenu: [],
						},
					],
				},

				'EXPLORER XLT': {
					Nombre: 'Explorer XLT',
					SubTitle: '',
					Menu: [
						{
							Nombre: 'Ficha técnica',
              Slug: 'tecnica',
							Icono: require('./../UI/canvas/CarMenu/btns/ficha.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/ficha-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Galería general',
              Slug: 'gallery',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Ver accesorios',
              Slug: 'accesorios',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Personaliza tu Ford',
              Slug: 'customize',
							Icono: require('./../UI/canvas/CarMenu/btns/detalle.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/detalle-selected.svg'),
							SubMenu: [
								{
									Nombre: 'Ver exterior',
									Icono: require('./../UI/canvas/CarMenu/btns/exterior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/exterior-selected.svg'),
								},
								{
									Nombre: 'Ver interior',
									Icono: require('./../UI/canvas/CarMenu/btns/interior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/interior-selected.svg'),
								},
							],
						},
						{
							Nombre: 'Cotiza este auto',
              Slug: 'quotation',
							Icono: require('./../UI/canvas/CarMenu/btns/cotiza.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/cotiza-selected.svg'),
							SubMenu: [],
						},
					],
				},

				'F-150 LARIAT SPORT': {
					Nombre: 'F-150 Lariat',
					SubTitle: 'Sport',
					Menu: [
						{
							Nombre: 'Ficha técnica',
              Slug: 'tecnica',
							Icono: require('./../UI/canvas/CarMenu/btns/ficha.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/ficha-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Galería general',
              Slug: 'gallery',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Ver accesorios',
              Slug: 'accesorios',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Personaliza tu Ford',
              Slug: 'customize',
							Icono: require('./../UI/canvas/CarMenu/btns/detalle.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/detalle-selected.svg'),
							SubMenu: [
								{
									Nombre: 'Ver exterior',
									Icono: require('./../UI/canvas/CarMenu/btns/exterior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/exterior-selected.svg'),
								},
								{
									Nombre: 'Ver interior',
									Icono: require('./../UI/canvas/CarMenu/btns/interior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/interior-selected.svg'),
								},
							],
						},
						{
							Nombre: 'Cotiza este auto',
              Slug: 'quotation',
							Icono: require('./../UI/canvas/CarMenu/btns/cotiza.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/cotiza-selected.svg'),
							SubMenu: [],
						},
					],
				},

				'F-150 XLT FHEV': {
					Nombre: 'F-150 XLT FHEV',
					SubTitle: '',
					Menu: [
						{
							Nombre: 'Ficha técnica',
              Slug: 'tecnica',
							Icono: require('./../UI/canvas/CarMenu/btns/ficha.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/ficha-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Galería general',
              Slug: 'gallery',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Ver accesorios',
              Slug: 'accesorios',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Personaliza tu Ford',
              Slug: 'customize',
							Icono: require('./../UI/canvas/CarMenu/btns/detalle.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/detalle-selected.svg'),
							SubMenu: [
								{
									Nombre: 'Ver exterior',
									Icono: require('./../UI/canvas/CarMenu/btns/exterior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/exterior-selected.svg'),
								},
								{
									Nombre: 'Ver interior',
									Icono: require('./../UI/canvas/CarMenu/btns/interior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/interior-selected.svg'),
								},
							],
						},
						{
							Nombre: 'Cotiza este auto',
              Slug: 'quotation',
							Icono: require('./../UI/canvas/CarMenu/btns/cotiza.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/cotiza-selected.svg'),
							SubMenu: [],
						},
					],
				},

				'F-150 PLATINUM FHEV': {
					Nombre: 'F-150 PLATINUM FHEV',
					SubTitle: '',
					Menu: [
						{
							Nombre: 'Ficha técnica',
              Slug: 'tecnica',
							Icono: require('./../UI/canvas/CarMenu/btns/ficha.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/ficha-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Galería general',
              Slug: 'gallery',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Ver accesorios',
              Slug: 'accesorios',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Personaliza tu Ford',
              Slug: 'customize',
							Icono: require('./../UI/canvas/CarMenu/btns/detalle.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/detalle-selected.svg'),
							SubMenu: [
								{
									Nombre: 'Ver exterior',
									Icono: require('./../UI/canvas/CarMenu/btns/exterior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/exterior-selected.svg'),
								},
								{
									Nombre: 'Ver interior',
									Icono: require('./../UI/canvas/CarMenu/btns/interior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/interior-selected.svg'),
								},
							],
						},
						{
							Nombre: 'Cotiza este auto',
              Slug: 'quotation',
							Icono: require('./../UI/canvas/CarMenu/btns/cotiza.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/cotiza-selected.svg'),
							SubMenu: [],
						},
					],
				},

				'F-150 RAPTOR': {
					Nombre: 'F-150 Raptor',
					SubTitle: '',
					Menu: [
						{
							Nombre: 'Ficha técnica',
              Slug: 'tecnica',
							Icono: require('./../UI/canvas/CarMenu/btns/ficha.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/ficha-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Galería general',
              Slug: 'gallery',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Ver accesorios',
              Slug: 'accesorios',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Personaliza tu Ford',
              Slug: 'customize',
							Icono: require('./../UI/canvas/CarMenu/btns/detalle.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/detalle-selected.svg'),
							SubMenu: [
								{
									Nombre: 'Ver exterior',
									Icono: require('./../UI/canvas/CarMenu/btns/exterior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/exterior-selected.svg'),
								},
								{
									Nombre: 'Ver interior',
									Icono: require('./../UI/canvas/CarMenu/btns/interior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/interior-selected.svg'),
								},
							],
						},
						{
							Nombre: 'Cotiza este auto',
              Slug: 'quotation',
							Icono: require('./../UI/canvas/CarMenu/btns/cotiza.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/cotiza-selected.svg'),
							SubMenu: [],
						},
					],
				},

				'MUSTANG MACH 1': {
					Nombre: 'Mustang Mach 1',
					SubTitle: '',
					Menu: [
						{
							Nombre: 'Ficha técnica',
              Slug: 'tecnica',
							Icono: require('./../UI/canvas/CarMenu/btns/ficha.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/ficha-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Galería general',
              Slug: 'gallery',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Ver accesorios',
              Slug: 'accesorios',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Personaliza tu Ford',
              Slug: 'customize',
							Icono: require('./../UI/canvas/CarMenu/btns/detalle.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/detalle-selected.svg'),
							SubMenu: [
								{
									Nombre: 'Ver exterior',
									Icono: require('./../UI/canvas/CarMenu/btns/exterior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/exterior-selected.svg'),
								},
								{
									Nombre: 'Ver interior',
									Icono: require('./../UI/canvas/CarMenu/btns/interior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/interior-selected.svg'),
								},
							],
						},
						{
							Nombre: 'Cotiza este auto',
              Slug: 'quotation',
							Icono: require('./../UI/canvas/CarMenu/btns/cotiza.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/cotiza-selected.svg'),
							SubMenu: [],
						},
					],
				},

				'MUSTANG GT PREMIUM': {
					Nombre: 'Mustang GT Premium',
					SubTitle: '',
					Menu: [
						{
							Nombre: 'Ficha técnica',
              Slug: 'tecnica',
							Icono: require('./../UI/canvas/CarMenu/btns/ficha.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/ficha-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Galería general',
              Slug: 'gallery',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Ver accesorios',
              Slug: 'accesorios',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Personaliza tu Ford',
              Slug: 'customize',
							Icono: require('./../UI/canvas/CarMenu/btns/detalle.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/detalle-selected.svg'),
							SubMenu: [
								{
									Nombre: 'Ver exterior',
									Icono: require('./../UI/canvas/CarMenu/btns/exterior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/exterior-selected.svg'),
								},
								{
									Nombre: 'Ver interior',
									Icono: require('./../UI/canvas/CarMenu/btns/interior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/interior-selected.svg'),
								},
							],
						},
						{
							Nombre: 'Cotiza este auto',
              Slug: 'quotation',
							Icono: require('./../UI/canvas/CarMenu/btns/cotiza.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/cotiza-selected.svg'),
							SubMenu: [],
						},
					],
				},

				'RANGER RAPTOR': {
					Nombre: 'Ranger Raptor',
					SubTitle: '',
					Menu: [
						{
							Nombre: 'Ficha técnica',
              Slug: 'tecnica',
							Icono: require('./../UI/canvas/CarMenu/btns/ficha.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/ficha-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Galería general',
              Slug: 'gallery',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						/*{
							Nombre: 'Ver accesorios',
              Slug: 'accesorios',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},*/
						{
							Nombre: 'Personaliza tu Ford',
              Slug: 'customize',
							Icono: require('./../UI/canvas/CarMenu/btns/detalle.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/detalle-selected.svg'),
							SubMenu: [
								{
									Nombre: 'Ver exterior',
									Icono: require('./../UI/canvas/CarMenu/btns/exterior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/exterior-selected.svg'),
								},
								{
									Nombre: 'Ver interior',
									Icono: require('./../UI/canvas/CarMenu/btns/interior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/interior-selected.svg'),
								},
							],
						},
						{
							Nombre: 'Cotiza este auto',
              Slug: 'quotation',
							Icono: require('./../UI/canvas/CarMenu/btns/cotiza.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/cotiza-selected.svg'),
							SubMenu: [],
						},
					],
				},

				'RANGER XL': {
					Nombre: 'Ranger XL',
					SubTitle: '',
					Menu: [
						/*{
							Nombre: 'Ficha técnica',
              Slug: 'tecnica',
							Icono: require('./../UI/canvas/CarMenu/btns/ficha.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/ficha-selected.svg'),
							SubMenu: [],
						},*/
						{
							Nombre: 'Galería general',
              Slug: 'gallery',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Ver accesorios',
              Slug: 'accesorios',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Personaliza tu Ford',
              Slug: 'customize',
							Icono: require('./../UI/canvas/CarMenu/btns/detalle.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/detalle-selected.svg'),
							SubMenu: [
								{
									Nombre: 'Ver exterior',
									Icono: require('./../UI/canvas/CarMenu/btns/exterior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/exterior-selected.svg'),
								},
								{
									Nombre: 'Ver interior',
									Icono: require('./../UI/canvas/CarMenu/btns/interior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/interior-selected.svg'),
								},
							],
						},
						{
							Nombre: 'Cotiza este auto',
              Slug: 'quotation',
							Icono: require('./../UI/canvas/CarMenu/btns/cotiza.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/cotiza-selected.svg'),
							SubMenu: [],
						},
					],
				},

				'RANGER XLS DIESEL': {
					Nombre: 'Ranger XLS Diesel',
					SubTitle: '',
					Menu: [
						/*{
							Nombre: 'Ficha técnica',
              Slug: 'tecnica',
							Icono: require('./../UI/canvas/CarMenu/btns/ficha.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/ficha-selected.svg'),
							SubMenu: [],
						},*/
						{
							Nombre: 'Galería general',
              Slug: 'gallery',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Ver accesorios',
              Slug: 'accesorios',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Personaliza tu Ford',
              Slug: 'customize',
							Icono: require('./../UI/canvas/CarMenu/btns/detalle.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/detalle-selected.svg'),
							SubMenu: [
								{
									Nombre: 'Ver exterior',
									Icono: require('./../UI/canvas/CarMenu/btns/exterior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/exterior-selected.svg'),
								},
								{
									Nombre: 'Ver interior',
									Icono: require('./../UI/canvas/CarMenu/btns/interior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/interior-selected.svg'),
								},
							],
						},
						{
							Nombre: 'Cotiza este auto',
              Slug: 'quotation',
							Icono: require('./../UI/canvas/CarMenu/btns/cotiza.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/cotiza-selected.svg'),
							SubMenu: [],
						},
					],
				},

				'BRONCO SPORT WILDTRAK': {
					Nombre: 'Bronco Sport Wildtrak',
					SubTitle: '',
					Menu: [
						{
							Nombre: 'Ficha técnica',
              Slug: 'tecnica',
							Icono: require('./../UI/canvas/CarMenu/btns/ficha.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/ficha-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Galería general',
              Slug: 'gallery',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Ver accesorios',
              Slug: 'accesorios',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Personaliza tu Ford',
              Slug: 'customize',
							Icono: require('./../UI/canvas/CarMenu/btns/detalle.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/detalle-selected.svg'),
							SubMenu: [
								{
									Nombre: 'Ver exterior',
									Icono: require('./../UI/canvas/CarMenu/btns/exterior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/exterior-selected.svg'),
								},
								{
									Nombre: 'Ver interior',
									Icono: require('./../UI/canvas/CarMenu/btns/interior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/interior-selected.svg'),
								},
							],
						},
						{
							Nombre: 'Cotiza este auto',
              Slug: 'quotation',
							Icono: require('./../UI/canvas/CarMenu/btns/cotiza.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/cotiza-selected.svg'),
							SubMenu: [],
						},
					],
				},

				'BRONCO SPORT BIG BEND': {
					Nombre: 'Bronco Sport Big Bend',
					SubTitle: '',
					Menu: [
						{
							Nombre: 'Ficha técnica',
              Slug: 'tecnica',
							Icono: require('./../UI/canvas/CarMenu/btns/ficha.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/ficha-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Galería general',
              Slug: 'gallery',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Ver accesorios',
              Slug: 'accesorios',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Personaliza tu Ford',
              Slug: 'customize',
							Icono: require('./../UI/canvas/CarMenu/btns/detalle.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/detalle-selected.svg'),
							SubMenu: [
								{
									Nombre: 'Ver exterior',
									Icono: require('./../UI/canvas/CarMenu/btns/exterior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/exterior-selected.svg'),
								},
								{
									Nombre: 'Ver interior',
									Icono: require('./../UI/canvas/CarMenu/btns/interior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/interior-selected.svg'),
								},
							],
						},
						{
							Nombre: 'Cotiza este auto',
              Slug: 'quotation',
							Icono: require('./../UI/canvas/CarMenu/btns/cotiza.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/cotiza-selected.svg'),
							SubMenu: [],
						},
					],
				},

				'BRONCO SPORT OUTER BANKS': {
					Nombre: 'Bronco Sport Outer Banks',
					SubTitle: '',
					Menu: [
						{
							Nombre: 'Ficha técnica',
              Slug: 'tecnica',
							Icono: require('./../UI/canvas/CarMenu/btns/ficha.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/ficha-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Galería general',
              Slug: 'gallery',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						}/*,
						{
							Nombre: 'Ver accesorios',
              Slug: 'accesorios',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						}*/,
						{
							Nombre: 'Personaliza tu Ford',
              Slug: 'customize',
							Icono: require('./../UI/canvas/CarMenu/btns/detalle.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/detalle-selected.svg'),
							SubMenu: [
								{
									Nombre: 'Ver exterior',
									Icono: require('./../UI/canvas/CarMenu/btns/exterior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/exterior-selected.svg'),
								},
								{
									Nombre: 'Ver interior',
									Icono: require('./../UI/canvas/CarMenu/btns/interior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/interior-selected.svg'),
								},
							],
						},
						{
							Nombre: 'Cotiza este auto',
              Slug: 'quotation',
							Icono: require('./../UI/canvas/CarMenu/btns/cotiza.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/cotiza-selected.svg'),
							SubMenu: [],
						},
					],
				},

				'RANGER FX4': {
					Nombre: 'Ranger FX4',
					SubTitle: '',
					Menu: [
						{
							Nombre: 'Ficha técnica',
              Slug: 'tecnica',
							Icono: require('./../UI/canvas/CarMenu/btns/ficha.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/ficha-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Galería general',
              Slug: 'gallery',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Ver accesorios',
              Slug: 'accesorios',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Personaliza tu Ford',
              Slug: 'customize',
							Icono: require('./../UI/canvas/CarMenu/btns/detalle.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/detalle-selected.svg'),
							SubMenu: [
								{
									Nombre: 'Ver exterior',
									Icono: require('./../UI/canvas/CarMenu/btns/exterior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/exterior-selected.svg'),
								},
								{
									Nombre: 'Ver interior',
									Icono: require('./../UI/canvas/CarMenu/btns/interior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/interior-selected.svg'),
								},
							],
						},
						{
							Nombre: 'Cotiza este auto',
              Slug: 'quotation',
							Icono: require('./../UI/canvas/CarMenu/btns/cotiza.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/cotiza-selected.svg'),
							SubMenu: [],
						},
					],
				},

				'RANGER XL CHASIS': {
					Nombre: 'Ranger XL Chasis',
					SubTitle: '',
					Menu: [
						/*{
							Nombre: 'Ficha técnica',
              Slug: 'tecnica',
							Icono: require('./../UI/canvas/CarMenu/btns/ficha.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/ficha-selected.svg'),
							SubMenu: [],
						},*/
						{
							Nombre: 'Galería general',
              Slug: 'gallery',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Ver accesorios',
              Slug: 'accesorios',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Personaliza tu Ford',
              Slug: 'customize',
							Icono: require('./../UI/canvas/CarMenu/btns/detalle.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/detalle-selected.svg'),
							SubMenu: [
								{
									Nombre: 'Ver exterior',
									Icono: require('./../UI/canvas/CarMenu/btns/exterior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/exterior-selected.svg'),
								},
								{
									Nombre: 'Ver interior',
									Icono: require('./../UI/canvas/CarMenu/btns/interior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/interior-selected.svg'),
								},
							],
						},
						{
							Nombre: 'Cotiza este auto',
              Slug: 'quotation',
							Icono: require('./../UI/canvas/CarMenu/btns/cotiza.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/cotiza-selected.svg'),
							SubMenu: [],
						},
					],
				},

				'RANGER XLT': {
					Nombre: 'Ranger XLT',
					SubTitle: '',
					Menu: [
						{
							Nombre: 'Ficha técnica',
              Slug: 'tecnica',
							Icono: require('./../UI/canvas/CarMenu/btns/ficha.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/ficha-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Galería general',
              Slug: 'gallery',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Ver accesorios',
              Slug: 'accesorios',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Personaliza tu Ford',
              Slug: 'customize',
							Icono: require('./../UI/canvas/CarMenu/btns/detalle.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/detalle-selected.svg'),
							SubMenu: [
								{
									Nombre: 'Ver exterior',
									Icono: require('./../UI/canvas/CarMenu/btns/exterior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/exterior-selected.svg'),
								},
								{
									Nombre: 'Ver interior',
									Icono: require('./../UI/canvas/CarMenu/btns/interior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/interior-selected.svg'),
								},
							],
						},
						{
							Nombre: 'Cotiza este auto',
              Slug: 'quotation',
							Icono: require('./../UI/canvas/CarMenu/btns/cotiza.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/cotiza-selected.svg'),
							SubMenu: [],
						},
					],
				},

				'RANGER LIMITED': {
					Nombre: 'Ranger Limited',
					SubTitle: '',
					Menu: [
						{
							Nombre: 'Ficha técnica',
              Slug: 'tecnica',
							Icono: require('./../UI/canvas/CarMenu/btns/ficha.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/ficha-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Galería general',
              Slug: 'gallery',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Ver accesorios',
              Slug: 'accesorios',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Personaliza tu Ford',
              Slug: 'customize',
							Icono: require('./../UI/canvas/CarMenu/btns/detalle.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/detalle-selected.svg'),
							SubMenu: [
								{
									Nombre: 'Ver exterior',
									Icono: require('./../UI/canvas/CarMenu/btns/exterior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/exterior-selected.svg'),
								},
								{
									Nombre: 'Ver interior',
									Icono: require('./../UI/canvas/CarMenu/btns/interior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/interior-selected.svg'),
								},
							],
						},
						{
							Nombre: 'Cotiza este auto',
              Slug: 'quotation',
							Icono: require('./../UI/canvas/CarMenu/btns/cotiza.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/cotiza-selected.svg'),
							SubMenu: [],
						},
					],
				},

				'RANGER LIMITED BLACK EDITION': {
					Nombre: 'Ranger Limited',
					SubTitle: 'Black Edition',
					Menu: [
						{
							Nombre: 'Ficha técnica',
              Slug: 'tecnica',
							Icono: require('./../UI/canvas/CarMenu/btns/ficha.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/ficha-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Galería general',
              Slug: 'gallery',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Ver accesorios',
              Slug: 'accesorios',
							Icono: require('./../UI/canvas/CarMenu/btns/galeria.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/galeria-selected.svg'),
							SubMenu: [],
						},
						{
							Nombre: 'Personaliza tu Ford',
              Slug: 'customize',
							Icono: require('./../UI/canvas/CarMenu/btns/detalle.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/detalle-selected.svg'),
							SubMenu: [
								{
									Nombre: 'Ver exterior',
									Icono: require('./../UI/canvas/CarMenu/btns/exterior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/exterior-selected.svg'),
								},
								{
									Nombre: 'Ver interior',
									Icono: require('./../UI/canvas/CarMenu/btns/interior.svg'),
									Icono2: require('./../UI/canvas/CarMenu/btns/interior-selected.svg'),
								},
							],
						},
						{
							Nombre: 'Cotiza este auto',
              Slug: 'quotation',
							Icono: require('./../UI/canvas/CarMenu/btns/cotiza.svg'),
							Icono2: require('./../UI/canvas/CarMenu/btns/cotiza-selected.svg'),
							SubMenu: [],
						},
					],
				},
			},
		];
	},
};
